'use strict';
angular.module('schoolLinqApp').factory('arCategoryService', [
	'$http',
	function ($http) {
		var endpoint = '/api/accounts-receivable/categories';

		function getARCategories() {
			return $http.get(endpoint);
		}

		function getARCategory(id) {
			return $http.get(endpoint + '/' + id);
		}

		function updateARCategory(customer) {
			return $http.put(endpoint + '/' + customer.Id, customer);
		}

		function addARCategory(category) {
			return $http.post(endpoint, category);
		}

		function deleteARCategory(id) {
			return $http.delete(endpoint + '/' + id);
		}

		return {
			getARCategories: getARCategories,
			addARCategory: addARCategory,
			getARCategory: getARCategory,
			updateARCategory: updateARCategory,
			deleteARCategory: deleteARCategory,
		};
	},
]);
